const replaceAll = String.prototype.replaceAll
  ? (str, find, rep) => str.replaceAll(find, rep)
  : (str, find, rep) => str.split(find).join(rep);

export default {
  numberSuffix(d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  },
  shuffleArray: function (arr) {
    return [...arr].map((_, i, arrCopy) => {
      let rand = i + Math.floor(Math.random() * (arrCopy.length - i));
      [arrCopy[rand], arrCopy[i]] = [arrCopy[i], arrCopy[rand]];
      return arrCopy[i];
    });
  },
  replaceUnderlineMarkersWithTags: function (text) {
    if (!text) return '';
    return this.replaceSpecialSymbolsInString(text, [
      ['[', '<u>'],
      [']', '</u>'],
    ]);
  },
  replaceSpecialSymbolsInString: function (text, arrayOfSymbols = []) {
    if (!text) return '';
    return arrayOfSymbols.reduce(
      (res, [find, rep]) => replaceAll(res, find, rep),
      text
    );
  },
};
